import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterResourceList',
  standalone: true
})
export class FilterResourceListPipe implements PipeTransform {
  transform(items: any[], name: string, type: string, system: string = 'All'): any {
    const byType = this.filterByType(items, type);
    const byName = this.filterByName(byType, name);

    return this.filterBySystem(byName, system);
  }

  filterByType(items: any[], type: string): any[] {
    return type === 'All' ? items : items.filter(item => item.type === type);
  }

  filterByName(items: any[], name: string): any[] {
    if (name.length < 1) {
      return items;
    }

    const term = name.toLowerCase();

    return items.filter(item => item.name.toLowerCase().includes(term));
  }

  filterBySystem(items: any[], system: string): any[] {
    switch (system) {
      case 'All':
        return items;

      case 'Custom':
        return items.filter(item => !item.system);

      default:
        return items.filter(item => item.systemName === system);
    }
  }
}
